// extracted by mini-css-extract-plugin
module.exports = {"Title":"MnEfb","Catalog":"VF184","Content":"DJSyV"};